define(['jquery', 'mrg-microevent'], function($, MicroEvent) {
    return function(app) {
        var requestedAction = app.settings.request.action,
            actionParams,
            emitted = false;

        if (requestedAction && typeof requestedAction !== 'string') {
            actionParams = requestedAction.params;
            requestedAction = requestedAction.name;
        }

        // disable actions on public
        if (app.isPublic()) {
            requestedAction = null;
        }

        var privateActions = {
            start: function() {
                // disable actions if newbie
                // LA popup will repeat it on agree

                // TODO унести это знание отсюда
                if (!emitted && requestedAction && !app.user.isNewbie() && !app.user.isFrozen()) {
                    // eslint-disable-next-line @typescript-eslint/no-use-before-define
                    queryActions.emit(requestedAction, actionParams);
                    app.emit('query-action:' + requestedAction, actionParams);
                    emitted = true;
                }
            },
        };

        var queryActions = {
            repeat: function() {
                privateActions.start();
            },

            isAction: function() {
                if (emitted) {
                    return false;
                } else {
                    return !!requestedAction;
                }
            },
        };

        MicroEvent.mixin(queryActions);

        // start action on load
        if (requestedAction) {
            // only for old users and private cloud
            var start = function() {
                privateActions.start();
                app.off('routeEnd', start);
            };

            app.on('routeEnd', start);
        }

        $.extend(app, {
            queryActions: queryActions,
        });
    };
});
